import React, { useContext } from 'react'

import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import shapes from '../../../svg/shapes/shape-map'
import * as S from './styled'

const Shape = ({
  className,
  name,
  size,
  rotate,
  color,
  gradient,
  posiTop,
  posiBottom,
  posiLeft,
  posiRight,
  zindex,
  ...props
}) => {
  const theme = useContext(ThemeContext)
  const Shape = shapes[name] || shapes[0]

  const gradientUUID = `shape-gradient-${uuidv4()}`

  return (
    <S.ShapeWrapper
      className={`shape shape-${name} ${className}`}
      size={size}
      rotate={rotate}
      zindex={zindex}
      color={color}
      gradient={gradient}
      gradientUUID={gradientUUID}
      posiTop={posiTop}
      posiBottom={posiBottom}
      posiLeft={posiLeft}
      posiRight={posiRight}
    >
      {gradient && (
        <svg className="shape-gradient" aria-hidden="true">
          <linearGradient id={gradientUUID} x2="1" y2="0">
            <stop offset="0%" stopColor={theme.color[gradient[0]]}></stop>
            <stop offset="100%" stopColor={theme.color[gradient[1]]}></stop>
          </linearGradient>
        </svg>
      )}
      <Shape className="shape-element" />
    </S.ShapeWrapper>
  )
}

Shape.defaultProps = {
  size: 32,
  color: 'neutral500'
}

Shape.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  rotate: PropTypes.number,
  gradient: PropTypes.array,
  zindex: PropTypes.number,
  posiTop: PropTypes.number,
  posiBottom: PropTypes.number,
  posiLeft: PropTypes.number,
  posiRight: PropTypes.number
}

export default Shape
